import React from 'react';
import { ShopifyOrder, LineItem } from '../types';
import './order-details.css';

interface OrderDetailsProps {
  order: ShopifyOrder;
}

const LineItemRow: React.FC<{ item: LineItem }> = ({ item }) => (
  <div className="line-item">
    <div className="line-item-title">{item.title}</div>
    <div className="line-item-info">
      <span>Cantidad: {item.quantity}</span>
      <span>SKU: {item.sku}</span>
      <span>Precio: ${parseFloat(item.price).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</span>
    </div>
  </div>
);

const OrderDetails: React.FC<OrderDetailsProps> = ({ order }) => {
  return (
    <div className="order-details">
      <h2>Detalles del Pedido</h2>
      
      <div className="order-summary">
        <div className="order-field">
          <span className="field-label">Número de Pedido:</span>
          <span className="field-value">{order.shopifyOrderId}</span>
        </div>
        
        <div className="order-field">
          <span className="field-label">Total:</span>
          <span className="field-value">${parseFloat(order.totalPrice).toLocaleString('es-MX', { minimumFractionDigits: 2 })} {order.currency}</span>
        </div>
        
        <div className="order-field">
          <span className="field-label">Estado del Pago:</span>
          <span className="field-value">{order.financialStatus === 'paid' ? 'Pagado' : order.financialStatus}</span>
        </div>
        
        <div className="order-field">
          <span className="field-label">Email:</span>
          <span className="field-value">{order.customerEmail}</span>
        </div>
      </div>
      
      <h3>Productos</h3>
      <div className="line-items">
        {order.lineItems.map((item) => (
          <LineItemRow key={item.id} item={item} />
        ))}
      </div>
    </div>
  );
};

export default OrderDetails; 